import alertFlow from 'common/alerts/containers/alert-saga';
import dashboardFlow from 'common/dashboard/containers/dashboard-saga';
import documentSagas from 'common/documents/containers/documents-saga';
import errorSagas from 'common/error/containers/error-sagas';
import messageCenterSagas from 'common/message-center/containers/message-center-sagas';
import navigationFlow from 'common/navigation/containers/navigation-saga';
import newsSagas from 'common/news/containers/news-saga';
import publishStepsSagas from 'common/publish-steps/containers/publish-steps-sagas';
import referenceDataSagas from 'common/reference-data/containers/reference-data-saga';
import timelineFlow from 'common/timeline/containers/timeline-saga';
import dynamicToolbarSagas from 'common/toolbar/containers/toolbar-dynamic-actions-saga';
import translationModalSaga from 'common/translate/containers/translation-modal-saga';
import userFlow from 'common/user/containers/user-saga';
import usersSagas from 'common/users/containers/users-dropdown-saga';
import customerSagas from 'customer/customer-sagas';
import draftSagas from 'drafts/containers/draft-sagas';
import equipmentSagas from 'equipment/equipment-sagas';
import systemMessageFlow from 'header/system-message/containers/system-message-sagas';
import uploadXMLFlow from 'header/upload-xml/containers/upload-xml-sagas';
import installedAtSagas from 'installed-at/installed-at-sagas';
import languageProviderSaga from 'language-provider/containers/language-provider-saga';
import notificationCallSagas from 'notification_call/containers/notification_call-saga';
import orderSagas from 'order/order-sagas';
import { all, cancelled, fork, take } from 'redux-saga/effects';
import searchFlow from 'search/containers/search-saga';
import userManagementSaga from 'settings/containers/user-management/user-management-saga';
import ticketFormFlow from 'tickets/containers/form/ticket-form-saga';
import smartActionSaga from 'tickets/containers/smart-action-sidepanel/smart-action-sidepanel-saga';
import logger from 'utils/logger';
import worklistFlow from 'worklist/containers/worklist-saga';
import filterSagas from './modules/common/filters/containers/filter-sagas';
import geoFilterSagas from './modules/common/filters/geo-filter/containers/geo-filter-sagas';
import ganttSagas from './modules/common/gantt/containers/gantt-sagas';
import directRoutesHandlerSagas from './modules/direct/containers/direct-routes-handler-sagas';
import functionalLocationSagas from './modules/functional-location/functional-location-sagas';
// eslint-disable-next-line max-len
import serviceCenterToggleSagas from './modules/header/service-center-toggle/containers/service-center-toggle-saga';
import landingZoneSaga from './modules/home/containers/landing-zone/landing-zone-saga';
import powerBiReportsSagas from './modules/power-bi/containers/power-bi-sagas';
import absenceSaga from './modules/settings/containers/absence/absence-saga';
import announcementsSagas from './modules/settings/containers/announcements/announcements-sagas';
import campaignsSagas from './modules/settings/containers/campaigns/campaigns-sagas';
import skillsSagas from './modules/settings/containers/skills/skills-sagas';
import workingHoursSaga from './modules/settings/containers/working-hours/working-hours-saga';
// eslint-disable-next-line max-len
import customerCenterConfigurationSagas from './modules/settings/containers/customer-center-configuration/customer-center-configuration-saga';
// eslint-disable-next-line max-len
import standaloneModeSagas from './modules/settings/containers/standalone-mode/standalone-mode-sagas';
import wipCodesSaga from './modules/settings/containers/wip-codes/wip-codes-saga';
import socketSagas from './modules/sockets/containers/socket-sagas';

export default function* rootSaga() {
  try {
    yield all([
      ...searchFlow,
      fork(userFlow),
      ...installedAtSagas,
      ...ticketFormFlow,
      ...timelineFlow,
      ...dashboardFlow,
      ...alertFlow,
      ...navigationFlow,
      ...systemMessageFlow,
      ...uploadXMLFlow,
      ...orderSagas,
      ...errorSagas,
      ...equipmentSagas,
      ...customerSagas,
      fork(referenceDataSagas),
      ...worklistFlow,
      ...draftSagas,
      ...dynamicToolbarSagas,
      ...usersSagas,
      ...documentSagas,
      ...newsSagas,
      ...notificationCallSagas,
      ...publishStepsSagas,
      ...messageCenterSagas,
      ...languageProviderSaga,
      ...translationModalSaga,
      ...smartActionSaga,
      ...userManagementSaga,
      ...ganttSagas,
      ...absenceSaga,
      ...filterSagas,
      ...workingHoursSaga,
      ...directRoutesHandlerSagas,
      ...serviceCenterToggleSagas,
      ...landingZoneSaga,
      ...skillsSagas,
      ...announcementsSagas,
      ...standaloneModeSagas,
      ...powerBiReportsSagas,
      ...geoFilterSagas,
      ...customerCenterConfigurationSagas,
      ...campaignsSagas,
      ...wipCodesSaga,
      ...functionalLocationSagas,
      ...socketSagas,
    ]);
    // wait for something catrastophic to happen
    // ==> error to bubble up to here
    yield take('SAGA_CANCELLED');
  } finally {
    if (yield cancelled()) {
      // something catrastophic happened:
      // all sagas stopped.
      // TODO: do something about it.
      logger.error('Sagas have stopped working');
    }
  }
}
